import subjectsImage from "../assets/homeSubjectsOffered.png";
import subjectHeroBg from "../assets/subjecthero.png";

const streams = [
  {
    id: "commerce",
    title: "Commerce Stream",
    items: [
      "English",
      "Accountancy",
      "Economics",
      "Business Studies",
      "Data Entry Operations",
      "Psychology",
      "Environmental Science",
      "Mass Communication",
      "Physical Education & Yoga",
    ],
  },
  {
    id: "science",
    title: "Science Stream",
    items: [
      "English",
      "Physics",
      "Chemistry",
      "Biology",
      "Mathematics",
      "Data Entry Operations",
      "Psychology",
      "Environmental Science",
      "Physical Education & Yoga",
    ],
  },
  {
    id: "arts",
    title: "Arts Stream",
    items: [
      "English",
      "History",
      "Geography",
      "Economics",
      "Political Science",
      "Data Entry Operations",
      "Psychology",
      "Physical Education & Yoga",
    ],
  },
];

function SubjectsOffered() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${subjectHeroBg})` }}
        aria-labelledby="subjects-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="subjects-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            Subjects Offered
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="subjects-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.12fr)] lg:items-stretch lg:gap-14 xl:gap-16">
            <div className="min-w-0 max-w-2xl text-left lg:max-w-none xl:pr-4">
              <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand sm:text-[0.8125rem]">
                Academics
              </p>
              <h2
                id="subjects-heading"
                className="mt-4 text-balance text-3xl font-bold tracking-tight text-ink sm:text-4xl md:text-[2.375rem] md:leading-tight"
              >
                Subjects Offered at Altus Online School
              </h2>
              <p className="mt-6 text-pretty text-base leading-relaxed text-ink/75 sm:mt-8 sm:text-lg">
                At Altus Online School, we provide the unparalleled flexibility of
                the NIOS and Cambridge board, allowing you to design a curriculum
                that perfectly aligns with your interests, career aspirations, and
                future university requirements.
              </p>
              <p className="mt-4 text-pretty text-base leading-relaxed text-ink/75 sm:text-[1.0625rem]">
                AOS empowers you with total freedom of choice. Students can select
                any combination of 5 to 7 subjects, seamlessly mixing and matching
                courses across Commerce, Science, and Arts to build a personalized
                academic pathway that is entirely their own.
              </p>

              <div className="mt-10 space-y-8 sm:mt-12">
                {streams.map((stream) => (
                  <div key={stream.id}>
                    <h3 className="text-base font-bold tracking-tight text-ink sm:text-lg">
                      {stream.title}
                    </h3>
                    <p className="mt-3 text-pretty text-sm leading-relaxed text-ink/72 sm:text-[0.9375rem]">
                      <span className="font-medium text-ink/75">
                        The subjects available are:{" "}
                      </span>
                      {stream.items.join(", ")}.
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative w-full lg:sticky lg:top-28 lg:h-full lg:min-h-0">
              <div className="relative h-96 w-full overflow-hidden rounded-2xl border border-brand/10 bg-white shadow-[0_18px_44px_-16px_rgba(30,22,51,0.14)] ring-1 ring-brand/5 sm:h-[28rem] md:h-[32rem] lg:h-full lg:min-h-[24rem]">
                <img
                  src={subjectsImage}
                  alt="Stack of books labelled Art, History, Math, Science, and Literature"
                  className="absolute inset-0 h-full w-full object-contain object-center"
                  width={800}
                  height={800}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SubjectsOffered;
